import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';
import includes from 'lodash/includes';
import stringify from 'qs/lib/stringify';

import { ToolSet, ToolSetInner } from '../../../../../components/ToolSet';
import RefineSearch from '../RefineSearch';
import { generateSearchPath, getDefaultParams } from '../../../../../utils/urlHelpers/engines';
import { getEnginesFacets } from '../../../../../store/actions';
import { getParamsFromLocationAndHistoryQueryString } from '../../../../../utils/featureToggles';

import './styles.css';

class RefineSearchSideBar extends PureComponent {
  state = {
    data: null
  }
  handleDataChange(data) {
    this.setState({
      data
    });
    this.handleSubmit();
  }
  handleSubmit() {
    this.requestData();
    this.setState({
      data: null
    });
  }

  requestData = () => {
    let otherParams = getParamsFromLocationAndHistoryQueryString({
      location: get(this.props, 'location', {}),
      history: get(this.props, 'history', {})
    });
    let params = getDefaultParams(get(this.props, 'match.params', {}));

    let newPath = generateSearchPath(this.state.data, {...params}, true);
    if (Object.keys(otherParams).length > 0) {
      newPath = `${newPath}?${stringify(otherParams)}`;
    }

    this.props.history.push(newPath);
  }

  render() {
    const loading = includes(get(this.props, 'componentWorking', []), 'facets');
    return (
      <div id="refine-search" className={classnames('search-tools refine-search', { submittable: this.state.data })}>
        <ToolSet>
          <ToolSetInner>
            <RefineSearch {...this.props} onDataChange={this.handleDataChange.bind(this)} position="desktop" loading={loading} />
          </ToolSetInner>
        </ToolSet>
      </div>
    );
  }
}

RefineSearchSideBar.propTypes = {
  match: PropTypes.object,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.object,
};

export default connect(null,
  dispatch => bindActionCreators({
    getEnginesFacets,
  }, dispatch))(RefineSearchSideBar);
